module.exports = __webpack_public_path__ + "img/logo.057081f7.png";